<template>
    <dx-grid
        :url="url"
        :columns="columns"
        :title="title"
        :onLoaded="onLoaded"
        :beforeSetupGrid="beforeSetupGrid"
    ></dx-grid>
</template>

<script>
import moment from "moment";

export default {
    data: () => ({
        title: "Student Class Info",
        url: "",
        userBranch: "",
        playingRow: null,
        playToken: 0,
        currentAudio: null,
        currentUtterance: null,

        columns: [
            {
                label: "Play",
                field: "play",
                template: "play-button-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Eng Name",
                field: "engName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Heb Name",
                field: "hebName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student ID",
                field: "studentID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "familyID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father Name",
                field: "firstName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father Name Hebrew",
                field: "firstNameH",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name",
                field: "lastName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name Hebrew",
                field: "lastNameH",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grand Parent 1",
                field: "grandParent1",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grand Parent 2",
                field: "grandParent2",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cell Phone",
                field: "cellPhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address1",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class",
                field: "class",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Building",
                field: "building",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Skip Card",
                field: "skipCard",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "DOB",
                field: "dob",
                type: "date",
                format: "MM/dd/yyyy",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Registered",
                field: "isRegistered",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Missing Requirements",
                field: "missingFamilyRequirements",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "tuitionBalance",
                label: "Tuition Balance",
                type: "number",
                format: "currency",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch Recording",
                template: "link-audio-cell-template",
                field: "branchRecordingFile",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher1 Recording",
                template: "link-audio-cell-template",
                field: "teacherNameRecording",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher2 Recording",
                template: "link-audio-cell-template",
                field: "teacherNameRecording2",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "List Type",
                field: "listType",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class Announcement",
                field: "classAnnouncement",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Is Public",
                field: "isPublic",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Public Date",
                field: "publicDate",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {
        this.columns.find((c) => c.field == "play").action = this.playClassInfo;
    },
    beforeDestroy() {
        this.stopClassInfoPlayback();
    },
    methods: {
        beforeSetupGrid() {
            this.userBranch = this.$store.state.authentication.branch;

            this.url =
                "studentsClassInfo?" +
                (this.userBranch != "null" ? "branch=" + this.userBranch : "");
        },
        // async onRowClicked(row) {
        //     this.$router.push({
        //         name: "Account View",
        //         params: {
        //             id: row.utaId,
        //         },
        //     });
        // },
        onLoaded(data) {
            if (!data.length) return;

            data.forEach((d) => (d.playIcon = "mdi-play-circle"));
        },
        playClassInfo(row) {
            if (this.playingRow === row && row.isPlaying) {
                this.stopClassInfoPlayback();
                return;
            }

            this.stopClassInfoPlayback();
            this.playClassInfoTwiml(row);
        },
        async playClassInfoTwiml(row) {
            const url =
                "https://api-3t6ck5zrrq-ue.a.run.app/tuitionAccountIvr/previewClassInfo?accountID=" +
                encodeURIComponent(row.familyID || "") +
                "&studentID=" +
                encodeURIComponent(row.studentID || "");

            row.isPlaying = true;
            row.playIcon = "mdi-pause-circle";
            this.playingRow = row;
            this.playToken += 1;
            const token = this.playToken;

            try {
                const xml = await fetch(url).then((response) => {
                    if (!response.ok) {
                        throw new Error("Class info preview failed");
                    }
                    return response.text();
                });

                if (token !== this.playToken) return;

                const items = this.parseTwimlPlaybackItems(xml);
                for (const item of items) {
                    if (token !== this.playToken) return;
                    const loops = item.loop > 0 ? item.loop : 1;
                    for (let i = 0; i < loops; i++) {
                        if (token !== this.playToken) return;
                        if (item.type === "play") {
                            await this.playAudioUrl(item.url, token);
                        } else if (item.type === "say") {
                            await this.speakText(item.text, token);
                        } else if (item.type === "pause") {
                            await this.pauseMs((item.length || 1) * 1000, token);
                        }
                    }
                }
            } catch (e) {
                console.error(e);
            } finally {
                if (token === this.playToken) {
                    this.resetClassInfoPlaybackIcon();
                }
            }
        },
        parseTwimlPlaybackItems(xml) {
            const doc = new DOMParser().parseFromString(xml, "text/xml");
            const items = [];

            const walk = (node) => {
                if (!node || !node.childNodes) return;

                for (const child of node.childNodes) {
                    if (child.nodeType !== 1) continue;

                    const name = (child.localName || child.nodeName || "").toLowerCase();
                    if (name === "play") {
                        const url = (child.textContent || "").trim();
                        if (url) {
                            items.push({
                                type: "play",
                                url,
                                loop: this.parseTwimlLoop(child),
                            });
                        }
                    } else if (name === "say") {
                        const text = (child.textContent || "").trim();
                        if (text) {
                            items.push({
                                type: "say",
                                text,
                                loop: this.parseTwimlLoop(child),
                            });
                        }
                    } else if (name === "pause") {
                        items.push({
                            type: "pause",
                            length: parseInt(child.getAttribute("length") || "1", 10) || 1,
                            loop: 1,
                        });
                    } else if (name !== "redirect") {
                        walk(child);
                    }
                }
            };

            walk(doc.documentElement);
            return items;
        },
        parseTwimlLoop(node) {
            const value = parseInt(node.getAttribute("loop") || "1", 10);
            return value > 0 ? value : 1;
        },
        playAudioUrl(url, token) {
            return new Promise((resolve) => {
                if (token !== this.playToken) {
                    resolve();
                    return;
                }

                const playUrl =
                    "https://api-3t6ck5zrrq-ue.a.run.app/tuitionAccountIvr/previewPlay?url=" +
                    encodeURIComponent(url);
                const audio = new Audio(playUrl);
                this.currentAudio = audio;
                audio.onended = () => resolve();
                audio.onerror = () => resolve();
                audio.play().catch(() => resolve());
            });
        },
        async speakText(text, token) {
            if (token !== this.playToken || !window.speechSynthesis) {
                return;
            }

            const voice = this.pickTwilioLikeVoice();
            const parts = text.split(/[,.]+/).map((part) => part.trim()).filter(Boolean);
            for (let i = 0; i < parts.length; i++) {
                if (token !== this.playToken) return;
                await this.speakPart(parts[i], voice, token);
                if (i < parts.length - 1) {
                    await this.pauseMs(250, token);
                }
            }
        },
        speakPart(text, voice, token) {
            return new Promise((resolve) => {
                if (token !== this.playToken) {
                    resolve();
                    return;
                }

                const utterance = new SpeechSynthesisUtterance(text);
                utterance.lang = "en-US";
                utterance.rate = 0.95;
                utterance.pitch = 0.85;
                if (voice) utterance.voice = voice;
                this.currentUtterance = utterance;
                utterance.onend = () => resolve();
                utterance.onerror = () => resolve();
                window.speechSynthesis.speak(utterance);
            });
        },
        pickTwilioLikeVoice() {
            const voices = window.speechSynthesis.getVoices() || [];
            return (
                voices.find((v) => /en-US/i.test(v.lang) && /male|david|mark|guy|matthew/i.test(v.name)) ||
                voices.find((v) => /en-US/i.test(v.lang)) ||
                voices.find((v) => /^en/i.test(v.lang)) ||
                null
            );
        },
        pauseMs(ms, token) {
            return new Promise((resolve) => {
                if (token !== this.playToken) {
                    resolve();
                    return;
                }
                setTimeout(resolve, ms);
            });
        },
        stopClassInfoPlayback() {
            this.playToken += 1;
            if (this.currentAudio) {
                this.currentAudio.pause();
                this.currentAudio.src = "";
                this.currentAudio = null;
            }
            if (window.speechSynthesis) {
                window.speechSynthesis.cancel();
            }
            this.currentUtterance = null;
            this.resetClassInfoPlaybackIcon();
        },
        resetClassInfoPlaybackIcon() {
            if (this.playingRow) {
                this.playingRow.isPlaying = false;
                this.playingRow.playIcon = "mdi-play-circle";
                this.playingRow = null;
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
</style>
